import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
//import Dashboard from '../views/Dashboard.vue'
//import Login from '../views/Login.vue'
import Solicitud from "../views/Solicitud.vue";
import Cursos from "../views/Cursos.vue";
import CursosMultiplicados from "../views/CursosMultiplicados.vue";
import CursosMultiplicadosDetalle from "../views/CursosMultiplicados/show.vue";
import GeneracionMasiva from "@/views/GeneracionMasiva/index";
import GeneracionMasivaDetalle from "@/views/GeneracionMasiva/show";
import ArchivadoMasivo from "@/views/Masivo/Archivado";
import EliminadoMasivo from "@/views/Masivo/Eliminado";
import SeguimientoAlumnos from "@/views/Masivo/Alumnos";

import Directores from "@/views/Directores";
import ResetPassMasivo from "@/views/ResetPassMasivo";

import CuentasUsuario from "@/views/CuentasUsuario/CuentasUsuario";
import PanelAdministradores from "@/views/CuentasUsuario/PanelAdministradores";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  //{
  //  path: "/about",
  //  name: "About",
  //  // route level code-splitting
  //  // this generates a separate chunk (about.[hash].js) for this route
  //  // which is lazy-loaded when the route is visited.
  //  component: () =>
  //    import(/* webpackChunkName: "about" */ "../views/About.vue"),
  //},
  /*{
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },*/
  {
    path: "/solicitud",
    name: "Solicitud",
    component: Solicitud,
  },
  {
    path: "/cursos",
    name: "Cursos",
    component: Cursos,
  },
  {
    path: "/cursos-multiplicados",
    name: "CursosMultiplicados",
    component: CursosMultiplicados,
  },
  {
    path: "/cursos-multiplicados/:id",
    name: "CursosMultiplicadosDetalle",
    component: CursosMultiplicadosDetalle,
  },
  {
    path: "/generacion-masiva",
    name: "GeneracionMasiva",
    component: GeneracionMasiva,
  },
  {
    path: "/generacion-masiva/:id",
    name: "GeneracionMasivaDetalle",
    component: GeneracionMasivaDetalle,
  },
  {
    path: "/archivado-masivo",
    name: "ArchivadoMasivo",
    component: ArchivadoMasivo,
  },
  {
    path: "/eliminado-masivo",
    name: "EliminadoMasivo",
    component: EliminadoMasivo,
  },
  {
    path: "/seguimiento-alumnos",
    name: "SeguimientoAlumnos",
    component: SeguimientoAlumnos,
  },
  {
    path: "/directores",
    name: "directores",
    component: Directores,
  },
  {
    path: "/reset-masivo",
    name: "ResetPassMasivo",
    component: ResetPassMasivo,
  },
  {
    path: "/cuentas-usuario",
    name: "CuentasUsuario",
    component: CuentasUsuario,
  },
  {
    path: "/panel-administrador",
    name: "PanelAdministradores",
    component: PanelAdministradores,
 },
  /*{
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
        guest: true
    }
  }*/
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
